import { ProjectProps } from "@/interfaces/project_types";
import { ProjectCard } from "./ProjectCard";

export function ManagerSection({ manager, projects, index }: { manager: string; projects?: ProjectProps[]; index: number; }) {
    return (
        <div key={index} className="my-5">
            <h4 className="px-2">Total Projects: {projects && projects.filter(project => project.manager?.name === manager).length}</h4>
            <div className="grid grid-cols-5 p-4 border-b-2 bg-slate-50">
                <h3>{manager}</h3>
                <h3>Project ID</h3>
                <h3>Project Name</h3>
                <h3>Client Name</h3>
                <h3>On-Going Status</h3>
            </div>

            <div>
                {projects && projects.filter(project => project.manager?.name === manager).map((project, index) => <ProjectCard project={project} index={index} key={index} />
                )}
            </div>
        </div>
    );
}
